var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMobile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_920_1497)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.4375 3.3125C37.316 3.3125 38.1586 3.66149 38.7798 4.28271C39.401 4.90392 39.75 5.74647 39.75 6.625V46.375C39.75 47.2535 39.401 48.0961 38.7798 48.7173C38.1586 49.3385 37.316 49.6875 36.4375 49.6875H16.5625C15.684 49.6875 14.8414 49.3385 14.2202 48.7173C13.599 48.0961 13.25 47.2535 13.25 46.375V6.625C13.25 5.74647 13.599 4.90392 14.2202 4.28271C14.8414 3.66149 15.684 3.3125 16.5625 3.3125H36.4375ZM16.5625 0C14.8054 0 13.1203 0.697989 11.8779 1.94042C10.6355 3.18285 9.9375 4.86794 9.9375 6.625V46.375C9.9375 48.1321 10.6355 49.8172 11.8779 51.0596C13.1203 52.302 14.8054 53 16.5625 53H36.4375C38.1946 53 39.8797 52.302 41.1221 51.0596C42.3645 49.8172 43.0625 48.1321 43.0625 46.375V6.625C43.0625 4.86794 42.3645 3.18285 41.1221 1.94042C39.8797 0.697989 38.1946 0 36.4375 0L16.5625 0Z",
    fill: "#E62569"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5 46.375C27.3785 46.375 28.2211 46.026 28.8423 45.4048C29.4635 44.7836 29.8125 43.941 29.8125 43.0625C29.8125 42.184 29.4635 41.3414 28.8423 40.7202C28.2211 40.099 27.3785 39.75 26.5 39.75C25.6215 39.75 24.7789 40.099 24.1577 40.7202C23.5365 41.3414 23.1875 42.184 23.1875 43.0625C23.1875 43.941 23.5365 44.7836 24.1577 45.4048C24.7789 46.026 25.6215 46.375 26.5 46.375Z",
    fill: "#E62569"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_920_1497"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 53,
    height: 53,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile);
export default __webpack_public_path__ + "static/media/mobile.13d416f72b15451385185699bdc064c3.svg";
export { ForwardRef as ReactComponent };